import { useRef } from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Modal } from '@chakra-ui/react';
import { colors } from '../../../theme';

const PdfViewModal = ({
  isOpen,
  onClose,
  pdfFile,
  iFrameProps,
  modalProps,
  title = 'PDF Viewer',
  toolbar = true,
}) => {
  const initialRef = useRef();
  const getPdf = () => {
    return `${pdfFile}${toolbar ? '' : '#toolbar=0'}`;
  };

  return (
    <Modal
      initialFocusRef={initialRef}
      isOpen={isOpen}
      onClose={() => onClose()}
      isCentered
      size="6xl"
      scrollBehavior="inside"
      {...modalProps}
    >
      <ModalOverlay />
      <ModalContent style={{ padding: '0.6rem 0' }}>
        <ModalCloseButton
          size="sm"
          style={{ background: colors.main.semiPrimary, color: colors.main.white }}
        />
        <ModalBody style={{ overflow: 'hidden' }}>
          {pdfFile && (
            <iframe
              ref={initialRef}
              title={title}
              src={getPdf()}
              {...iFrameProps}
              type="application/pdf"
            />
          )}
          {!pdfFile && <div>File path or url not found</div>}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

PdfViewModal.propTypes = {
  pdfFile: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  toolbar: PropTypes.bool,
  iFrameProps: PropTypes.objectOf(PropTypes.any),
  modalProps: PropTypes.objectOf(PropTypes.any),
};

PdfViewModal.defaultProps = {
  title: 'PDF Viewer',
  toolbar: true,
  iFrameProps: {},
  modalProps: {},
};

export default PdfViewModal;
